<template>
<div class="loginContainer">
    <div class="topTitleBox">
        <img src="@/assets/img/kx_logo.png" alt="">
        <span>新媒体事业部消耗表系统</span>
    </div>
    <div class="content" v-loading='loading'>
        <h3>消耗表导出</h3>
        <div class="inputItem">
            <label>月份</label>
            <el-date-picker
                size="small"
                v-model="month"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月">
            </el-date-picker>
        </div>
        <div class="inputItem">
            <label>时间</label>
            <el-date-picker
                size="small"
                v-model="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间">
            </el-date-picker>
        </div>
        <button class="loginButton" @click="exportEvent">导出</button>
    </div>
</div>
</template>
<script>
export default {
    data(){
        return{
            loading:false,
            month:'',
            date:''
        }
    },
    methods:{
        exportEvent(){
            if(this.month == ''){
                this.$message({
                    message: '请选择月份',
                    type: 'warning'
                })
                return
            }
            if(this.date == ''){
                this.$message({
                    message: '请选择时间',
                    type: 'warning'
                })
                return
            }
            this.loading = true;
            this.$axios.get(this.URL.BASEURL + this.URL.orderHistoryExport,{
                params:{
                   month:this.month,
                   etime:this.date
                }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(!res||res.length==0){
                    this.$message({
                        message: '暂无数据',
                        type: 'warning'
                    })
                }else{
                    this.$exportOrder({order:res})
                }
            }).catch(()=>{
                this.$message({
                    message: '服务器错误！',
                    type: 'warning'
                })
                this.loading = false;
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.loginContainer{
    width: 100%;
    min-height: 100vh;
    background: url('../assets/img/loginBg.png') no-repeat;
    background-size:100% 100%;
    .topTitleBox{
        text-align: center;
        padding-top: 46px;
        img{
            display: inline-block;
            height: 43px;
            vertical-align: middle;
        }
        span{
            color: #FFFFFF;
            font-size: 29px;
            line-height: 40px;
            display: inline-block;
            margin-left: 12px;
            &::before{
                content: '';
                display: inline-block;
                width: 2px;
                height: 28px;
                background: #FFFFFF;
                vertical-align: middle;
                margin-right: 12px;
                margin-top: -3px;
            }
        }
    }
    .content{
        width: 399px;
        background: #FFFFFF;
        padding: 20px 30px 40px;
        border-radius: 6px;
        margin: auto;
        margin-top: 100px;
        h3{
            color: #02043C;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            margin-bottom: 24px;
        }
        .inputItem{
            margin-bottom: 20px;
            label{
                color: #666666;
                font-size: 12px;
                line-height: 17px;
                display: inline-block;
                width: 50px;
                text-align: right;
            }
            .input{
                width: 100%;
                height: 40px;
                border-radius: 4px;
                font-size: 13px;
                margin-top: 5px;
            }
        }
        .loginButton{
            width: 200px;
            height: 40px;
            display: block;
            background: #5B7BFE;
            border-radius: 2px;
            color:#FFFFFF;
            font-size: 13px;
            border: none;
            border-radius: 4px;
            margin: auto;
            margin-top: 30px;
        }
        .loginHine{
            color:#010235;
            font-size: 12px;
            line-height: 17px;
            text-align: center;
            margin-top: 30px;
            span{
                color: #5B7BFE;
                font-weight: 500;
                cursor: pointer;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/orderHistoryExport.vue